<partial-loading-indicator class="dex-lp-w_loading-indicator">

    <div class="dex-lp-w_plates">
        @let isLpCollapsed = !!widgetImpl.$expandedSymbol();
        <dex-lp-part-plate
            [isCollapsed]="isLpCollapsed"
            [isExpandCollapseEnabled]="true">
            <dex-lp-details-part
                [lp]="lp()"
                [tranches]="traches()"
                [isCollapsed]="isLpCollapsed"
                [isSymbolClickable]="true"
                (toggleCollapsed)="handleToggleCollapsed(true, undefined)"
                (symbolClick)="handleSymbolClick($event)">
            </dex-lp-details-part>
        </dex-lp-part-plate>

        @for (tranche of traches(); track tranche.raw.poolTrancheId) {
            @let trSymbol = tranche.unitDeliverable.symbol;
            @let isTrancheCollapsed = widgetImpl.$expandedSymbol() !== trSymbol;
            <dex-lp-part-plate
                [isCollapsed]="isTrancheCollapsed"
                [isExpandCollapseEnabled]="true">
                <dex-tranche-details-part
                    [tranche]="tranche"
                    [isCollapsed]="isTrancheCollapsed"
                    [isExpandCollapseEnabled]="true"
                    [isSymbolClickable]="true"
                    (toggleCollapsed)="handleToggleCollapsed(false, trSymbol)"
                    (symbolClick)="handleSymbolClick($event)">
                </dex-tranche-details-part>
            </dex-lp-part-plate>
        }
    </div>

</partial-loading-indicator>
